import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["instance"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { loadMOP } from './PaymentState.actions';
import { transformLoadMopPayload } from './helpers/transformLoadMopPayload';
var LoadMopLogic = function LoadMopLogic(middleware) {
  return middleware.startListening({
    actionCreator: loadMOP,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, _ref) {
        var _action$payload, instance, selectedMop, transformedPayload, _ref2, transformedInstance, rest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _objectDestructuringEmpty(_ref);
              _action$payload = action.payload, instance = _action$payload.instance, selectedMop = _action$payload.selectedMop;
              transformedPayload = transformLoadMopPayload(action, instance, selectedMop);
              _ref2 = transformedPayload === null || transformedPayload === void 0 ? void 0 : transformedPayload.payload, transformedInstance = _ref2.instance, rest = _objectWithoutProperties(_ref2, _excluded);
              transformedInstance.hydrate(rest);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default LoadMopLogic;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/LoadMop.listener.js
// module id = 4394
// module chunks = 11